jQuery(".add-location-btn").on("click", function () {
  jQuery("#addLocationPopup").fadeIn();
});
jQuery("#delLocationBtn").on("click", function () {
  jQuery("#delLocationPopup").fadeIn();
});
jQuery(document).on("click", "#reOrderBtn", function () {
  jQuery("#reOrderPopup").fadeIn();
});
jQuery(document).on("click", "#deleteInventoryBtn", function () {
  jQuery("#removeInventoryPopup").fadeIn();
});

jQuery(".popup-actions .cancel-btn").on("click", function () {
  jQuery(this).closest(".popup-overlay").fadeOut();
});

// open cart
jQuery(document).on("click","#cartTrigger",function () {
  jQuery("#cartDrawerMain,.cartDrawer-overlay").fadeIn();
  // jQuery("").fadeIn();
});
// close cart
jQuery(document).on("click","#cartDrawerMain .close-btn",function () {
  jQuery(this).closest("#cartDrawerMain").fadeOut();
  jQuery(".cartDrawer-overlay").fadeOut();
});

// open customer notification
jQuery(document).on("click","#notificationDrawerTrigger",function () {
  jQuery("#customerNotificationDrawer,.customer-notification-overlay").fadeIn();
  
});
// close customer notification
jQuery(document).on("click","#customerNotificationClosebtn",function () {
  jQuery("#customerNotificationDrawer").fadeOut();
  jQuery(".customer-notification-overlay").fadeOut();
});



// quanity update in popup
jQuery(document).ready(function () {
  

  // When the popup opens, set the initial value (if needed)
  function openPopup() {
    jQuery("#quantity-input").val(""); // Ensure the input is empty to show placeholder
  }

  // Trigger the popup open function when the popup is shown
  openPopup(); // You can call this when the popup opens in your real code

  // Increase quantity
 
  // show hide content when toggle is checked in popup
  jQuery("#toggle-input").change(function () {
    if (jQuery(this).is(":checked")) {
      jQuery("#hidden-content").show(); // Show the div
    } else {
      jQuery("#hidden-content").hide(); // Hide the div
    }
  });
});


jQuery('#openSidebarBtn').on('click', function() {
  if (jQuery(this).hasClass('closeSidebarBtn')) {
    jQuery('#sidebar').removeClass('sidebar-active');
    jQuery(this).removeClass('closeSidebarBtn');
  } else {
    jQuery('#sidebar').addClass('sidebar-active');
    jQuery(this).addClass('closeSidebarBtn');
  }
});

